<template>
  <q-input
    v-model="search"
    clearable
    placeholder="Discount Code"
    :loading="loading"
    hint="If you have a discount code, enter it here"
    error-message="This coupon is invalid and will not be applied"
    style="width: 250px;"
    :error="isInvalid"
    :debounce="900"
    @update:model-value="checkCoupon"
  >
    <template v-if="hasChecked && !isInvalid" #append>
      <q-icon
        name="done"
        color="green-7"
      />
    </template>
  </q-input>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      default: null
    }
  },
  emits: ['update:model-value'],
  data () {
    return {
      search: null,
      loading: false,
      hasChecked: false
    }
  },
  computed: {
    isInvalid () {
      return this.hasChecked && !this.modelValue
    }
  },
  methods: {
    async checkCoupon () {
      this.hasChecked = false
      if (!this.search) {
        return
      }

      this.loading = true
      const { status, payload } = await this.$post('v1/plans/coupon', {
        coupon: this.search
      })
      this.loading = false
      this.hasChecked = true
      if (status === 'success') {
        this.$emit('update:model-value', payload)
      }
    }
  }
}
</script>
